import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { leadValidationColumns } from "assets/properties/properties";
import { leadValidationvalue } from "assets/properties/properties";

const LeadValidation = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteStructureId, setDeleteStructureId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  // submit create function
  const handlecreatestructureSubmit = () => {
    navigate(`/coreservice/leadValidation-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LEAD_VALIDATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };
  const validationname = (code) => {
    const item = leadValidationvalue?.find((item) => item.code === code);
    return item?.name;
  };
  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((lead, index) => {
        let row = {
          code: lead?.id,
          name: validationname(lead?.validationName),
          validationValue: lead?.validationValue,
          status: lead?.active ? "Active" : "Inactive",
          action: getIcons(lead?.id),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit lead"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete lead"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (code) => {
    navigate(`/coreservice/leadValidation/` + code);
  };
  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Lead Validation");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteStructureId(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteStructureId("");
  };
  const handlePositiveResponse = async () => {
    const structureid = deleteStructureId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Structure
    const res = await apiHandler({
      url: endpoint.LEAD_VALIDATION_DELETE + structureid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete lead validation is successful", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row?.validationName?.toLowerCase().includes(val.toLowerCase()) ||
        row?.validationValue?.toLowerCase().includes(val.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Lead Validation"
          button1="Create Lead Validation"
          button1click={handlecreatestructureSubmit}
          onSearchChange={onSearchChange}
          search
          searchLabel="Search For Structure"
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={leadValidationColumns}
            rows={selectedTableData}
          />
        </TableContainer>
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

export default LeadValidation;
